import { render } from "./SmSubHeaderProperties.vue?vue&type=template&id=7cfd77ca&scoped=true"
import script from "./SmSubHeaderProperties.vue?vue&type=script&lang=js"
export * from "./SmSubHeaderProperties.vue?vue&type=script&lang=js"

import "./SmSubHeaderProperties.vue?vue&type=style&index=0&id=7cfd77ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cfd77ca"]])

export default __exports__